import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Assets from "visual-components/assets/assets";
import LegalDocuments from "visual-components/legalDocuments/legalDocuments";
import TrackingLinks from "visual-components/trackingLinks/trackingLinks";

export default class LinksFiles extends Component {
  render() {
    return (
      <div
        style={{
          paddingTop: "16px",
        }}
      >
        <Helmet>
          <title>Links & Files - DojoMojo</title>
        </Helmet>

        <TrackingLinks />
        <LegalDocuments />
        <Assets />
      </div>
    );
  }
}
